import { graphql } from 'gql';

export const catalogUERBaseCostGql = graphql(`
    query catalogUERBaseCost($catalogUniqueId: String!, $uerBaseCostId: Long!) {
        catalogUERBaseCost(catalogUniqueId: $catalogUniqueId, uerBaseCostId: $uerBaseCostId) {
            data {
                catalogUERBaseCostWorkScopes {
                    id
                    name
                    number
                }
                chapter
                code
                constructionTypes {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                version
                directCost
                emm
                eqp
                fot
                groupId
                groupName
                id
                mtr
                name
                nr
                ozp
                pir
                ratios {
                    code
                    id
                    name
                    ratioType
                    catalogRatioGroupId
                }
                ratioGroups {
                    groupType
                    id
                    name
                    parentId
                }
                sectionId
                sectionName
                sp
                trn
                tz
                tm
                uerClassifier
                uniqueId
                unit
                unitCost
                updatedAt
                workType {
                    workCode
                    workInSum
                    workName
                    workRatio
                    workUniqueId
                    workUnit
                }
                zpm
                sections {
                    id
                    order
                    name
                    prices {
                        id
                        code
                        name
                        unit
                        estimateTotal
                        type
                        hasConsumptionRateMtr
                        quantity {
                            unit
                            total
                            consumptionRateMtr
                        }
                        unitCost {
                            total
                            ozp
                            emm
                            zpm
                            mtr
                        }
                        totalCost {
                            total
                            ozp
                            emm
                            zpm
                            mtr
                            nr
                            sp
                        }
                        unitWorkCost {
                            tz
                            tm
                        }
                        totalWorkCost {
                            tz
                            tm
                        }
                        resources {
                            id
                            code
                            name
                            unit
                            type
                            isDeleted
                            isNotCount
                            quantity {
                                unit
                                total
                            }
                            unitCost {
                                total
                                ozp
                                emm
                                zpm
                                mtr
                            }
                            totalCost {
                                total
                                ozp
                                emm
                                zpm
                                mtr
                            }
                        }
                    }
                }
                justification
            }
        }
    }
`);

export const catalogParseUerBaseCostBasisGql = graphql(`
    query catalogParseUerBaseCostBasis($content: FileInput!) {
        catalogParseUerBaseCostBasis(content: $content) {
            actionRequired
            buttonText
            code
            data {
                baseCost {
                    ozp
                    emm
                    zpm
                    mtr
                    fot
                    eqp
                    pir
                    trn
                    nr
                    sp
                    unitCost
                    directCost
                    tz
                    tm
                    sections {
                        order
                        name
                        prices {
                            code
                            name
                            unit
                            estimateTotal
                            type
                            hasConsumptionRateMtr
                            vr2001
                            naclMask
                            quantity {
                                unit
                                total
                                consumptionRateMtr
                            }
                            unitCost {
                                total
                                ozp
                                emm
                                zpm
                                mtr
                            }
                            totalCost {
                                total
                                ozp
                                emm
                                zpm
                                mtr
                                nr
                                sp
                            }
                            unitWorkCost {
                                tz
                                tm
                            }
                            totalWorkCost {
                                tz
                                tm
                            }
                            resources {
                                code
                                name
                                unit
                                type
                                isDeleted
                                isNotCount
                                quantity {
                                    unit
                                    total
                                }
                                unitCost {
                                    total
                                    ozp
                                    emm
                                    zpm
                                    mtr
                                }
                                totalCost {
                                    total
                                    ozp
                                    emm
                                    zpm
                                    mtr
                                }
                            }
                        }
                    }
                }
                general {
                    sectionName
                    groupName
                    code
                    name
                    chapter
                    unit
                    workScopes {
                        number
                        name
                    }
                }
                version
                workTypeItems {
                    caption
                    category
                    nacl
                    naclCurr
                    naclMask
                    plan
                    planCurr
                    planMask
                    nrCode
                    spCode
                    workID
                    catFile
                }
                uerNacl
                uerPlan
                catFile
                workID
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
            }
        }
    }
`);

export const catalogUERBaseCostConstructionTypesGql = graphql(`
    query catalogUERBaseCostConstructionTypes(
        $skip: Int
        $take: Int
        $catalogUniqueId: String!
        $where: ConstructionTypeDataFilterInput
        $order: [ConstructionTypeDataSortInput!]
    ) {
        catalogUERBaseCostConstructionTypes(
            skip: $skip
            take: $take
            catalogUniqueId: $catalogUniqueId
            where: $where
            order: $order
        ) {
            items {
                contractFileName
                catalogId
                code
                fullName
                iconCode
                id
                name
                shortName
                uniqueId
                updatedAt
                createdAt
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const catalogCreateUerBaseCostGql = graphql(`
    mutation catalogCreateUerBaseCost($costData: CreateCatalogUERBaseCostInput!) {
        catalogCreateUerBaseCost(costData: $costData) {
            data {
                catalogUERBaseCostWorkScopes {
                    id
                    name
                    number
                }
                chapter
                code
                constructionTypes {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                emm
                eqp
                groupId
                groupName
                id
                mtr
                name
                nr
                ozp
                pir
                sectionId
                sectionName
                sp
                trn
                uerClassifier
                uniqueId
                unit
                unitCost
                updatedAt
                workType {
                    workCode
                    workInSum
                    workName
                    workRatio
                    workUniqueId
                    workUnit
                }
                zpm
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
